import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonEvents, RadioButtonsProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-radiobuttons',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: BlFrontendRadiobuttonsComponent,
    },
  ],
  styles: [
    `
      :host.bl-core-radio-buttons-bordered ::ng-deep .bl-core-radio-button {
        border: 1px solid var(--blg-grey-200);
        border-radius: 0.5rem; /* rounded-lg */
        padding: 1rem;
        padding-bottom: 0.5rem;
      }
    `,
  ],
})
export class BlFrontendRadiobuttonsComponent
  extends BlFrontendBaseComponent<RadioButtonsProps, RadioButtonEvents>
  implements ControlValueAccessor
{
  @Input() items: RadioButtonsProps['items'];
  @Input() name: RadioButtonsProps['name'] = '';
  @Input() direction: RadioButtonsProps['direction'] = 'column';
  @Input() bordered = false;
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();

  @HostBinding('class.bl-core-radio-buttons-bordered') get isBordered() {
    return this.bordered;
  }

  onChange = (_: string) => {};
  onTouched = () => {};

  writeValue(value: string): void {
    this.updateCheckedOnItemWithValue(value);
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.updateProps({ disabled: isDisabled });
  }

  protected override getComponentName(): string {
    return 'RadioButtons';
  }

  protected override getProps(): RadioButtonsProps {
    return {
      name: this.name,
      items: this.items,
      direction: this.direction,
      onChange: (value: string) => {
        this.onTouched();
        this.onChange(value);
        this.valueChanged.emit(value);
      },
    };
  }

  private updateCheckedOnItemWithValue(value: string): void {
    const updatedItems = this.items.map((item) => ({
      ...item,
      checked: item.value === value,
    }));
    this.updateProps({ items: updatedItems });
  }
}
